import * as React from 'react';
import { createElement } from 'react';
import { Button } from '@alifd/next';
import './index.scss';
export class OadpButton extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let { name, id, label, field, type, size, disabled, text, onClick, style, __designMode, ...otherProps } = this.props;
        if (__designMode === 'design') {
            onClick = (e) => {
                console.log('design mode oadp-button click');
            };
        }
        return (createElement(Button, Object.assign({ type: type, size: size, disabled: disabled, text: text, style: style, onClick: onClick }, otherProps), label));
    }
}
export default OadpButton;
